import React from "react";
import { Grid } from "@material-ui/core";
import FilterTogglebar from "../common/FilterTogglebar";
import IndustryView from "./IndustryView";
import IndustryViewResponsive from "./IndustryViewResponsive";
import { industry } from "./constants";
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const IndustryContainer = () => {
  const {
    loadIndustryShortages,
    loadIndustryMetrics,
    resetSelectedIndustry,
    setSelectedIndustry,
  } = userActions();
  const { chart_selected } = useSelector((state) => state.water_user);
  const { isMobile } = useGetViewPortDimensions();

  const handleChange = (value, scenarioValue) => {
    loadIndustryShortages(scenarioValue === 1 ? "DCP Cuts" : "Deeper Cuts");
    setSelectedIndustry(industry[value - 1]);
  };

  const componentMount = () => {
    loadIndustryShortages("DCP Cuts");
    loadIndustryMetrics();
    return () => {
      resetSelectedIndustry();
    };
  }
  React.useEffect(componentMount, []);

  return (
    <Grid container>
      {!isMobile ? <FilterTogglebar
        title="Water User: Type of Industry"
        options={industry}
        value={1}
        handleChange={handleChange}
        scenario_disabled={chart_selected === 0 ? true : false}
      /> : null}
      {isMobile ? <IndustryViewResponsive /> : <IndustryView />}
    </Grid>
  );
};

export default IndustryContainer;
